import { http } from 'vue'

export default {
  // load addresses from the API server
  loadAddresses (context, params = {}) {
    let filter = (params.neighborhood_id) ? '&neighborhood_id=' + params.neighborhood_id : ''
    return http.get('addresses' + '?addressable_id=' + params.data.addressable_id + '&addressable_type=' + params.data.addressable_type + filter)
  },
  // create address at the API server
  postAddress (context, params = {}) {
    return http.post('addresses', params.data)
  },
  // edit address at the API server
  putAddress (context, params = {}) {
    return http.put('addresses/' + params.id, params.data)
  },
  // delete address at the API server
  deleteAddress (context, params = {}) {
    return http.delete('addresses/' + params.id)
  },
  // save addresses at the store
  saveAddress (context, payload) {
    context.commit('SAVE_ADDRESS', payload)
  },
  // save addresses at the store
  saveAddresses (context, payload) {
    context.commit('SAVE_ADDRESSES', payload)
  },
  // load CEP from the API server
  loadCep (context, params = {}) {
    return http.get('ceps/' + params.cep)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/addresses/actions.js